/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Danish (Denmark)
export default {
  'editorExtensionLinkCreate.confluencePage.newDraftTitle': 'Side uden titel',
  'editorExtensionLinkCreate.confluencePage.quickInsert.description': 'Opret en ny side, og indsæt den som et link',
  'editorExtensionLinkCreate.confluencePage.quickInsert.title': 'Opret Confluence-side',
  'editorExtensionLinkCreate.confluencePage.successFlag.action.open': 'Åbn i Confluence',
  'editorExtensionLinkCreate.confluencePage.successFlag.description': 'Din side er oprettet',
  'editorExtensionLinkCreate.confluencePage.successFlag.title': 'Siden blev oprettet',
  'editorExtensionLinkCreate.confluencePage.title': 'Opret ny side',
  'editorExtensionLinkCreate.genericError.description': 'Opdater siden, og prøv igen.',
  'editorExtensionLinkCreate.genericError.title': 'Noget gik galt',
  'editorExtensionLinkCreate.jiraIssue.quickInsert.description':
    'Opret en sag på samme linje, og indsæt sagen som et link',
  'editorExtensionLinkCreate.jiraIssue.quickInsert.description-issue-terminology-refresh-m4':
    'Opret en indlejret sag, og indsæt sagen som et link',
  'editorExtensionLinkCreate.jiraIssue.quickInsert.title': 'Opret Jira-sag',
  'editorExtensionLinkCreate.jiraIssue.quickInsert.title-issue-terminology-refresh-m4': 'Opret Jira-sag',
  'editorExtensionLinkCreate.jiraIssue.successFlag.action.open': 'Åbn i Jira',
  'editorExtensionLinkCreate.jiraIssue.successFlag.description': 'Din sag er oprettet',
  'editorExtensionLinkCreate.jiraIssue.successFlag.description-issue-terminology-refresh-m4': 'Din sag er oprettet',
  'editorExtensionLinkCreate.jiraIssue.successFlag.title': 'Sagen blev oprettet',
  'editorExtensionLinkCreate.jiraIssue.successFlag.title-issue-terminology-refresh-m4': 'Sagen blev oprettet',
  'editorExtensionLinkCreate.jiraIssue.title': 'Opret ny sag',
  'editorExtensionLinkCreate.jiraIssue.title-issue-terminology-refresh-m4': 'Opret ny sag',
  'editorExtensionLinkCreate.keyword.create': 'opret',
  'editorExtensionLinkCreate.keyword.issue': 'sag',
  'editorExtensionLinkCreate.keyword.new': 'ny',
  'editorExtensionLinkCreate.keyword.page': 'side',
  'editorExtensionLinkCreate.keyword.publish': 'udgiv',
  'editorExtensionLinkCreate.keyword.raise': 'opret',
  'editorExtensionLinkCreate.keyword.space': 'område',
  'editorExtensionLinkCreate.keyword.ticket': 'supportanmodning',
};
